// extracted by mini-css-extract-plugin
module.exports = {"customers":"_2Qea2ktDj1rfg3o8qQvvgm","container":"_2SEo6a4R5gG0jXO-V04bH","container-full-nosub":"_3FSXAkHhRrXGmHOhlRSwTQ"};